import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { AvisoDTO, AvisoResponseDTO } from '../../models/avisos/aviso.model';

/**
 * Service de gerenciamento de Avisos.
 *
 * Cobre o endpoint REST `/avisos` do backend (AvisoController):
 * - GET /avisos                       (listagem paginada com filtros)
 * - GET /avisos/{id}                  (busca por id)
 * - GET /avisos/filtro-ativo          (filtro por ativo + tipoAviso)
 * - GET /avisos/filtro-ativo-para-aviso (filtro por ativo, exclui certos tipos)
 * - POST /avisos                      (criar)
 * - PUT /avisos/{id}                  (atualizar)
 *
 * Obs.: O endpoint nao define DELETE, entao a baixa logica e feita
 * marcando `ativo = false` via PUT.
 */
@Injectable({ providedIn: 'root' })
export class AvisoService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<AvisoResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<AvisoResponseDTO>(path);
  }

  getById<T>(url: string): Observable<AvisoDTO> {
    return this.apiService.read<AvisoDTO>(url);
  }

  post<T>(url: string, data: AvisoDTO): Observable<AvisoDTO> {
    return this.apiService.create<AvisoDTO>(url, data);
  }

  put<T>(url: string, data: AvisoDTO): Observable<AvisoDTO> {
    return this.apiService.update<AvisoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
